import { Icon } from "~/components/icon";
import { useCommitStatusColors } from "~/hooks/useCommitStatusColors";
import { cn } from "~/utils";

interface CommitsBehindBadgeProps {
  behindBy: number;
  className?: string;
  isByoc?: boolean;
  currentCommitDate?: string | null;
}

export function CommitsBehindBadge({
  behindBy,
  className,
  isByoc = false,
  currentCommitDate,
}: CommitsBehindBadgeProps) {
  const colors = useCommitStatusColors(behindBy, isByoc, currentCommitDate);

  return (
    <div
      className={cn(
        "inline-flex min-w-0 max-w-full items-center gap-1 whitespace-nowrap text-xs font-medium tabular-nums",
        colors.text,
        className,
      )}
      title={
        behindBy === 0
          ? "On the latest commit"
          : `${behindBy.toLocaleString()} commits behind the latest commit`
      }
    >
      <Icon
        name="GitCompare"
        size={12}
        className={cn("shrink-0", colors.icon)}
      />
      <span className="truncate">
        {behindBy === 0 ? "up to date" : `${behindBy.toLocaleString()} behind`}
      </span>
    </div>
  );
}
